// extracted by mini-css-extract-plugin
export default {"global-layout":"Global_global-layout__IxgtL","global-layout__body":"Global_global-layout__body__xCYKL","global-layout__body--body":"Global_global-layout__body--body__IBf-o"};